export default __webpack_public_path__ + "static/media/kim3.73ad650d.png";